import { render } from "./Department.vue?vue&type=template&id=7428399d&scoped=true"
import script from "./Department.vue?vue&type=script&lang=ts"
export * from "./Department.vue?vue&type=script&lang=ts"

import "./Department.vue?vue&type=style&index=0&id=7428399d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7428399d"

export default script